// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":2,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\",\"sourceMap\":false}!../../../../../node_modules/postcss-loader/lib/index.js?{\"config\":{\"path\":\"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-1921/tools/webpack/postcss.config.js\"},\"sourceMap\":true}!../../../../../node_modules/less-loader/dist/cjs.js?{\"outputStyle\":\"expanded\",\"sourceMap\":false}!./orientation-card.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../../node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":2,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\",\"sourceMap\":false}!../../../../../node_modules/postcss-loader/lib/index.js?{\"config\":{\"path\":\"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-1921/tools/webpack/postcss.config.js\"},\"sourceMap\":true}!../../../../../node_modules/less-loader/dist/cjs.js?{\"outputStyle\":\"expanded\",\"sourceMap\":false}!./orientation-card.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":2,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\",\"sourceMap\":false}!../../../../../node_modules/postcss-loader/lib/index.js?{\"config\":{\"path\":\"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-1921/tools/webpack/postcss.config.js\"},\"sourceMap\":true}!../../../../../node_modules/less-loader/dist/cjs.js?{\"outputStyle\":\"expanded\",\"sourceMap\":false}!./orientation-card.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/home/presentational/orientation-card.less
// module id = L9UG
// module chunks = 1